module.exports = __webpack_public_path__ + "static/media/location.25a769cc.svg";